<template>
  <div class="preview-product">
    <div class="nav-row">
      <div class="nav-back">
        <v-btn icon x-small type="button" class="nav-back__button" @click="goBack">
          <v-icon size="16" class="nav-back__icon">mdi-arrow-left</v-icon>
        </v-btn>
        <div class="nav-back__title">Products</div>
      </div>
      <router-link target="_blank" :to="{ name: 'website.products.update', params: { id: product._id } }">
        <v-btn icon class="open-btn" title="Edit product">
          <v-icon size="16">mdi-open-in-new</v-icon>
        </v-btn>
      </router-link>
    </div>
    <div class="product-content">
      <div class="product-identity">
        <h1 class="product-title">{{ product.title || 'Untitled Product' }}</h1>
        <p class="meta-updated">Updated {{ updatedDate }}</p>
      </div>
      <div class="images-wrapper" :class="{ 'images-wrapper--empty': !product.images || product.images.length === 0 }">
        <ProductImages :images="product.images" />
      </div>
      <div v-if="product.bodyHtml" class="product-body" v-html="product.bodyHtml" />
    </div>
  </div>
</template>

<script>
import ProductImages from './ProductImages.vue';
import moment from 'moment';

export default {
  components: { ProductImages },
  name: 'PreviewProduct',
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    goBack() {
      this.$emit('go-back');
    },
  },
  computed: {
    updatedDate() {
      return moment(this.product.updatedDate).format('MMM D, YYYY');
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-product {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

/* Navigation row */
.nav-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  border-bottom: 1px solid var(--v-border-base);
}

.nav-back {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  transition: color 0.15s ease;
  outline: none;
  margin-left: -6px;
}
.nav-back__title {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.02em;
  user-select: none;
}
.nav-back__button {
  flex-shrink: 0;
  height: 28px;
  width: 28px;
}

.open-btn {
  flex-shrink: 0;
  height: 28px;
  width: 28px;
}

.product-content {
  flex: 1 1 auto;
  overflow-x: hidden;
  overflow-y: auto;
  min-height: 0;

  @media (max-width: 900px) {
    border-right: none;
  }
}

/* Product identity */
.product-identity {
  padding: 14px 16px 2px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.product-title {
  font-size: 15px;
  font-weight: 600;
  line-height: 1.5;
  margin: 0;
  text-transform: none;
  word-break: break-word;
}
.meta-updated {
  font-size: 12px;
  opacity: 0.8;
  margin: 0;
  letter-spacing: 0.01em;
}

.images-wrapper {
  padding: 16px;

  &.images-wrapper--empty {
    padding: 8px;
  }
}

.product-body {
  container-type: inline-size;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 999px;
}

::-webkit-scrollbar-thumb {
  background: #d0d1d3;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #c8cbd0;
}
</style>
